import { createI18n } from "vue-i18n";

import en from "./en.json";
import fr from "./fr.json";
import dateTimeFormats from "./dateTimeFormats.json";

export const i18n = createI18n({
  locale: "fr-FR",
  messages: {
    "en-US": en,
    "en-GB": en,
    "fr-FR": fr,
  },
  datetimeFormats: dateTimeFormats,
  fallbackLocale: "fr-FR",
  legacy: false,
});
